import { createContext, type RefObject, useContext } from 'react';

import type { TooltipDelayConfig, TooltipPositionType } from './types';

export interface TooltipProviderContextValue extends TooltipDelayConfig {
    skipDelayOnOpen?: boolean;
}

const TooltipProviderContext = createContext<TooltipProviderContextValue>({
    delayHide: 0,
    delayShow: 0,
    skipDelayOnOpen: false,
});

export const useTooltipProvider = (): TooltipProviderContextValue => useContext(TooltipProviderContext);

export { TooltipProviderContext };

export interface CursorPosition {
    x: number;
    y: number;
}

export interface TooltipContextValue {
    contentId: string;
    cursorPosition: CursorPosition;
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
    position: TooltipPositionType;
    setCursorPosition: (position: CursorPosition) => void;
    setPosition: (position: TooltipPositionType) => void;
    triggerRef: RefObject<HTMLElement | null>;
}

const TooltipContext = createContext<TooltipContextValue | null>(null);

export const useTooltip = (): TooltipContextValue => {
    const context = useContext(TooltipContext);
    if (!context) {
        throw new Error('Tooltip components must be used within a <Tooltip> component');
    }
    return context;
};

export { TooltipContext };
